import { Socket } from "socket.io-client"
import { AppDispatch } from "../../redux/store/store"
import { ValueType } from "pokal_api"

export type SocketEventInputs = {
    currentlySelectedPatient: string | null
    currentlySelectedValueType: ValueType | null
}

class SocketEvent<OUTPUT> {
    private key: string
    private handle: (
        args: OUTPUT,
        input: SocketEventInputs,
        dispatch: AppDispatch
    ) => void

    constructor(
        key: string,
        handle: (
            args: OUTPUT,
            input: SocketEventInputs,
            dispatch: AppDispatch
        ) => void
    ) {
        this.key = key
        this.handle = handle
    }

    public register(
        socket: Socket,
        input: SocketEventInputs,
        dispatch: AppDispatch
    ) {
        socket.on(this.key, (args) => {
            this.handle(args as OUTPUT, input, dispatch)
        })
    }
}

export default SocketEvent
